export var DEFAULT_SLIDE_ELEMENT_INDEX = -1;
export var DEFAULT_SLIDE_INDEX = 0;
export var SYSTEM_FONT = '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Helvetica, sans-serif';